module.exports = __webpack_public_path__ + "img/85b03c4.svg";